import React from "react";
import "./Receiver_info_holder.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
// import Cancel_Order_btn from "../../../common-components/common_btn/cancel_Order_btn/Cancel_Order_btn";
import { useNavigate } from "react-router-dom";
import Cancel_Order_Btn from "../../../common-components/common-btn/cancel_order_btn/Cancel_Order_Btn";

function Receiver_info_holder({ order, showCancelBtn }) {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/cancel-order");
  };
  return (
    <>
      <section className="Receiver_info_holder">
        <div className="text_holder">
          <h4>{order?.User?.name}</h4>
          <div className="name_holder">
            <div>
              <div className="icon_holder">
                <FontAwesomeIcon className="info_icon" icon={faPhone} />
              </div>
            </div>
            <p> +91 {order?.User?.contact_no}</p>
          </div>

          <p>Apartment</p>
          <div className="name_holder">
            <div>
              <div className="icon_holder">
                <FontAwesomeIcon className="info_icon" icon={faLocationDot} />
              </div>
            </div>
            <p>
              {" "}
              {order?.User_Address?.building}, {order?.User_Address?.floor},{" "}
              {order?.User_Address?.apartment}, {order?.User_Address?.street},
              {order?.User_Address?.direction},{" "}
              {order?.User_Address?.Users_Address_Detail?.City?.name},
              {order?.User_Address?.Users_Address_Detail?.State?.name}, –{" "}
              {order?.User_Address?.Users_Address_Detail?.Pincode?.name},{" "}
              {order?.User_Address?.Users_Address_Detail?.Country?.name}.
            </p>
          </div>
          {/* {showCancelBtn && (
                        <Cancel_Order_Btn btnText={"Cancel Order"} onClick={handleClick} />
                    )} */}
        </div>
      </section>
    </>
  );
}

export default Receiver_info_holder;
